import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import api from "@/lib/api";

export default function Insights() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Insights | Labpronics Technologies";
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);
  return (
    <Layout>
      <PageHero eyebrow="Insights" title="Perspectives & Technical Notes" subtitle="Field notes and reference architectures on coastal surveillance, government cybersecurity and smart-governance infrastructure." image="/generated/classroom.jpg" />
      <section className="py-20">
        <div className="container-lp grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <Link to={`/insights/${p.slug}`} data-testid={`blog-card-${i}`} className="group block bg-white border border-lp-border rounded-sm overflow-hidden hover:border-lp-cyan hover:shadow-[0_20px_40px_-24px_rgba(10,43,110,0.35)] transition-all h-full">
                <div className="img-zoom h-48"><img src={p.cover_image} alt={p.title} loading="lazy" className="w-full h-full object-cover" /></div>
                <div className="p-6">
                  <span className="text-[11px] font-600 tracking-wide uppercase text-lp-cyan">{p.category}</span>
                  <h3 className="font-heading font-600 text-lg text-lp-blue mt-2 leading-snug group-hover:text-lp-steel transition-colors">{p.title}</h3>
                  <p className="text-sm text-lp-muted mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                  <div className="mt-4 text-xs text-lp-muted">{p.read_time}</div>
                </div>
              </Link>
            </Reveal>
          ))}
          {posts.length === 0 && <p className="text-lp-muted">Insights coming soon.</p>}
        </div>
      </section>
    </Layout>
  );
}
